import * as jquery from "jquery";
import * as knockout from "knockout";
import * as globalConfig from "globalConfig";
import { PriceDisplayModel } from "Content/ts/Models/Shared/Pricing/pricingModels";

export const Deps = {
    $: jquery,
    ko: knockout,
    globalConfig: globalConfig
}

class PricingBindings {
    constructor() {
        Deps.ko.bindingHandlers.displayPrice = {
            update: (element: any, valueAccessor: KnockoutObservable<PriceDisplayModel | KnockoutObservable<PriceDisplayModel>>) => {
                const price = Deps.ko.unwrap(valueAccessor());
                const priceToDisplay = this.findPriceToDisplay(price);
                let priceString = "N/A";

                if (priceToDisplay != null) {
                    priceString = priceToDisplay.toFixed(2);
                }

                if (element.nodeName === 'INPUT') {
                    Deps.$(element).val(priceString);
                } else {
                    const currency = Deps.globalConfig.CurrencySymbol;
                    Deps.ko.utils.setTextContent(element, (currency || '') + priceString);
                }
            }
        };
    }

    findPriceToDisplay(price: PriceDisplayModel) {
        if (!price) {
            return 0;
        }

        if (price.IsGross) {
            return price.GrossAmount;
        }
        return price.NetAmount;
    }
}

var bindings = new PricingBindings();
export { bindings as PricingBindings };